/**
 * Centralized credentials configuration
 *
 * All credentials are now loaded from environment variables (.env.local)
 * This ensures they can be easily changed without code modifications.
 *
 * IMPORTANT: These are PUBLIC keys (client-side) - safe to expose in the browser.
 * Examples: reCAPTCHA Site Key, EmailJS Public Key, Google Analytics ID, etc.
 *
 * For PRIVATE/SECRET keys (API secrets, private tokens, etc.):
 * - Store them in backend/.env files
 * - Never expose them to the client-side
 */

const getEnvVar = (key: string, fallback?: string): string => {
  const value = process.env[key];
  if (!value) {
    if (fallback) {
      console.warn(`Missing env variable: ${key}, using fallback`);
      return fallback;
    }
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
};

// EmailJS Configuration
export const EMAIL_JS_CONFIG = {
  serviceId: getEnvVar('REACT_APP_EMAILJS_SERVICE_ID'),
  templateId: getEnvVar('REACT_APP_EMAILJS_TEMPLATE_ID'),
  publicKey: getEnvVar('REACT_APP_EMAILJS_PUBLIC_KEY'),
} as const;

// Google reCAPTCHA Configuration
export const RECAPTCHA_CONFIG = {
  siteKey: getEnvVar('REACT_APP_RECAPTCHA_SITE_KEY'),
} as const;
